
  var tests = [];
  module.exports = tests;




// WEBPACK FOOTER //
// ./project/client/src/core/vendor/browsernizr/lib/tests.js